import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { ModalTransition } from '@atlaskit/modal-dialog';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { JiraModal as ModalDialog } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import type { featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal$key } from '@atlassian/jira-relay/src/__generated__/featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal.graphql';
import type { OnInstallSuccess } from '@atlassian/jira-software-empty-state-experience-feature-flags/src/common/types.tsx';
import { FeatureFlagEmptyStateExperienceEntryPoint } from '@atlassian/jira-software-empty-state-experience-feature-flags/src/ui/async.tsx';

export const FeatureFlagEmptyStateExperienceModal = ({
	isOpen,
	onClose,
	devOpsFeatureFlagProviders,
	onInstallSuccess,
	returnFocusRef,
}: {
	isOpen: boolean;
	onClose: () => void;
	devOpsFeatureFlagProviders: featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal$key;
	onInstallSuccess: OnInstallSuccess;
	returnFocusRef?: React.RefObject<HTMLButtonElement>;
}): React.JSX.Element => {
	const featureFlagProviders = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal on DevOpsFeatureFlagProvider
			@relay(plural: true) {
				...async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint
			}
		`,
		devOpsFeatureFlagProviders,
	);

	const entryPoint = (
		<FeatureFlagEmptyStateExperienceEntryPoint
			onInstallSuccess={onInstallSuccess}
			devOpsFeatureFlagProviders={featureFlagProviders}
			isOpen={isOpen}
			onClose={onClose}
		/>
	);

	return (
		<ModalTransition>
			{isOpen ? (
				<ShortcutScope>
					<ModalDialog
						shouldReturnFocus={returnFocusRef}
						onClose={onClose}
						width={592}
						autoFocus={false}
						messageId="software-releases-version-detail-issue-list.ui.issues.feature-flags-empty-state.modal-dialog"
						messageType="transactional"
					>
						{entryPoint}
					</ModalDialog>
				</ShortcutScope>
			) : null}
		</ModalTransition>
	);
};
